export default {
  ACTIVE: "active",
  INVISIBLE: "invisible",
  HIDDEN: "hidden",
  IS_OPEN: "is-open",
};
